var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29439 7.0361C8.24782 6.78575 8.25694 6.52821 8.32112 6.28177C8.38529 6.03534 8.50294 5.80606 8.66571 5.61021C8.82848 5.41437 9.03237 5.25677 9.26291 5.14861C9.49345 5.04045 9.74498 4.98438 9.99964 4.98438C10.2543 4.98438 10.5058 5.04045 10.7364 5.14861C10.9669 5.25677 11.1708 5.41437 11.3336 5.61021C11.4963 5.80606 11.614 6.03534 11.6782 6.28177C11.7423 6.52821 11.7515 6.78575 11.7049 7.0361L10.9893 10.8478C10.9457 11.0784 10.823 11.2865 10.6423 11.4362C10.4616 11.5859 10.2343 11.6679 9.99964 11.6679C9.76498 11.6679 9.53768 11.5859 9.35699 11.4362C9.1763 11.2865 9.05354 11.0784 9.00993 10.8478L8.29439 7.0361ZM11.2535 13.7593C11.2535 14.0918 11.1214 14.4107 10.8862 14.6459C10.6511 14.881 10.3322 15.0131 9.99964 15.0131C9.66709 15.0131 9.34817 14.881 9.11303 14.6459C8.87788 14.4107 8.74578 14.0918 8.74578 13.7593C8.74578 13.4267 8.87788 13.1078 9.11303 12.8727C9.34817 12.6375 9.66709 12.5054 9.99964 12.5054C10.3322 12.5054 10.6511 12.6375 10.8862 12.8727C11.1214 13.1078 11.2535 13.4267 11.2535 13.7593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIcon);
export default __webpack_public_path__ + "static/media/critical-icon.c8749299e0e4958270155daa1c76ddce.svg";
export { ForwardRef as ReactComponent };